import { get, post } from "@app/common/api";

type ImpersonatePermissionResponse = { allowed: boolean };

export const getImpersonatePermission = async (): Promise<boolean> => {
  const json: ImpersonatePermissionResponse = await get("/users/impersonate", {
    withCreds: true,
  });

  return json.allowed;
};

export const postImpersonate = async (impersonatedUserEmail: string) => {
  return post(
    "/users/impersonate",
    { impersonatedUserEmail },
    { withCreds: true }
  );
};
